import {
  Home,
  Link2,
  Tag,
  FileText,
  Clock,
  Eye,
  Pencil,
  ExternalLink,
  MoreVertical
} from "lucide-react"
import styles from "./PageCard.module.css"

const PageCard = ({
  Icon = Home,
  title,
  slug,
  status,
  seoTitle,
  seoDesc,
  time,
  onEdit,
  views,
  type = "static",
  category
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.left}>
          <div
            className={
              type === "content"
                ? styles.iconContent
                : status === "Published"
                ? styles.icon
                : styles.iconDisabled
            }
          >
            <Icon size={18} color="#ffffff" />
          </div>

          <div className={styles.titleBlock}>
            <div className={styles.titleRow}>
              <h3 className={styles.title}>{title}</h3>

              {type === "content" && category && (
                <span className={`${styles.category} ${styles[category]}`}>
                  {category}
                </span>
              )}
            </div>

            <div className={styles.slugRow}>
              <Link2 size={12} className={styles.linkIcon} />
              <span className={styles.slug}>{slug}</span>
            </div>
          </div>
        </div>

        <div className={styles.right}>
          <span
            className={
              status === "Published"
                ? styles.statusPublished
                : styles.statusDraft
            }
          >
            {status}
          </span>
          <MoreVertical size={18} className={styles.kebab} />
        </div>
      </div>

      <div className={styles.metaBox}>
        <div className={styles.metaRow}>
          <Tag size={14} className={styles.metaIcon} />
          <span>{seoTitle}</span>
        </div>
        <div className={styles.metaRow}>
          <FileText size={14} className={styles.metaIcon} />
          <span>{seoDesc}</span>
        </div>
      </div>

      <div className={styles.footer}>
        <div className={styles.footerMeta}>
          <span>
            <Clock size={12} /> {time}
          </span>
          <span>
            <Eye size={12} /> {views} views
          </span>
        </div>

        <div className={styles.actions}>
          <button className={type === "content" ? styles.editContentBtn : styles.editBtn} onClick={onEdit}>
            <Pencil size={14} color="#ffffff" />
            Edit
          </button>
          <button className={type === "content" ? styles.openContentBtn : styles.openBtn}>
            <ExternalLink size={14} color="#ffffff" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default PageCard
